export default __webpack_public_path__ + "static/image 1-836e7b61466b9d89ed061ac52e15b778.png";